// extracted by mini-css-extract-plugin
export var completionBody = "_m9-2";
export var completionCard = "_m9-0";
export var completionFooter = "_m9-3";
export var completionTitle = "_m9-1";